import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) =>
	state.api.network.dns.domain.transfer.createOutgoing;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_TRANSFER_CREATEOUTGOING',
	method: 'POST',
	url: '/network/dns/domain/transfer/createOutgoing.json',
});

export { actions, reducer, sagas, selectors };
